import * as types from './calendarModuleActionType';
import type { CalendarMutationRequest } from '@/types/calendarModule';

export const calendarModuleListRequest = (
  payload: { calendar_type?: string } = {}
): types.CalendarModuleListRequest => ({
  type: types.CALENDAR_MODULE_LIST_REQUEST,
  payload,
});

export const calendarEventListRequest = (
  payload: Record<string, unknown>
): types.CalendarEventListRequest => ({
  type: types.CALENDAR_EVENT_LIST_REQUEST,
  payload,
});

export const calendarSourceListRequest = (
  calendar_id: number
): types.CalendarSourceListRequest => ({
  type: types.CALENDAR_SOURCE_LIST_REQUEST,
  payload: { calendar_id },
});

export const calendarLookupRequest = (
  payload: types.CalendarLookupRequest['payload']
): types.CalendarLookupRequest => ({
  type: types.CALENDAR_LOOKUP_REQUEST,
  payload,
});

export const calendarMutationRequest = (
  payload: CalendarMutationRequest
): types.CalendarMutationRequestAction => ({
  type: types.CALENDAR_MUTATION_REQUEST,
  payload,
});

export const calendarModuleProcessReset = () => ({
  type: types.CALENDAR_MODULE_PROCESS_RESET,
});
